<template>
  <div class="c-content">
    <div class="cheader">
      <div class="ct-top w-1200">
        <div class="img" @click="goHome">
        </div>
        <div class="right">
          <ul>
            <li class="margin-right-13" @click="goUser">注册</li>
            <li class="active" @click="goUser">登录</li>
          </ul>
        </div>
      </div>
      <div class="ct-bot">
        <div class="w-1200 flexed">
          <div class="c-btn" :class="nowNav===item.text?'c-btn-active':''" v-for="(item,index) in navList"
               @click="gopath(item,index)">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        navList: [
          {text: '首页', path: 'home'},
          {text: '协会概况', path: 'comityall'},
          {text: '新闻动态', path: 'news'},
          {text: '会员服务', path: 'vip'},
          {text: '分支机构', path: 'branch'},
          {text: '国际交流', path: 'gooble'},
          {text: '专题活动', path: 'theme'},
          {text: '学术研究', path: 'study'},
        ]
      }

    },
    components: { // 组件
    },
    computed: { // 计算属性
      nowNav() {
        return this.$store.state.homeNavValue
      }
    },
    methods: {
      goUser() {
        window.open('http://user.zggz.org.cn/#/login', '_blank');
      },
      goHome () {
        this.$router.push({name: 'home'})
      },
      setMeg() {
        this.msg = '我是改变后的数据'
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      gopath(res, index) {
        this.$router.push({
          name: res.path
        });
        this.$store.commit('changeHomeNavValue', {
          name: res.text
        })
      }
    },
    beforeCreate() { // 实例刚刚被创建
    },
    created() { //实例已经创建完成
    },
    beforeMount() { // 模板编译之前
    },
    mounted() { // 模板编译完成
    },
    beforeUpdate() { // 数据更新之前
    },
    updated() { // 数据更新完毕
    },
    beforeDestroy() { // 实例销毁之前
    },
    destroyed() { // 实例销毁完成
    },
    watch: {
      example: {
        handler(val) {
          if (val.example) {
          }
        },
        deep: true
      },
    }
  }
</script>

<style scoped>
  .cheader {
    width: 100%;
  }

  .ct-top {
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .img {
    width: 360px;
    height: 68px;
    background-color: red;
    cursor: pointer;
    background: url("../assets/logo_1.png");
  }

  .right ul {
    display: flex;
  }

  .right ul li {
    list-style-type: none;
    width: 60px;
    height: 30px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(175, 9, 11, 1);
    border-radius: 4px;
    line-height: 30px;
    font-size: 18px;
    /*font-family:PingFang-SC-Medium;*/
    font-weight: 500;
    color: rgba(175, 9, 11, 1);
    cursor: pointer;
    letter-spacing: 2px;
    text-align: center;
  }

  .active {
    background: rgba(175, 9, 11, 1) !important;
    color: white !important;
  }

  .ct-bot {
    width: 100%;
    /*height:60px;*/
    background: rgba(182, 11, 13, 1);
  }

  .c-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    border-left: 1px solid #d68584;
    font-size: 18px;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
    position: relative;
  }

  .c-btn:hover {
    color: rgba(182, 11, 13, 1);
    background-color: white;
    /*font-size:22px;*/
    /*font-family:MicrosoftYaHei-Bold;*/
    font-weight: bold;
    width: 150px;
    border-left: 1px solid #d68584;
  }

  .c-btn:hover + .c-btn {
    border-left: 1px solid #d68584;
  }

  .c-btn:hover::after {
    content: "";
    width: 150px;
    height: 1px;
    background-color: rgba(182, 11, 13, 1);
    position: absolute;
    left: 0;
    top: 0;
  }

  .c-btn-active {
    color: rgba(182, 11, 13, 1);
    background-color: white;
    font-size: 18px;
    /*font-family:MicrosoftYaHei-Bold;*/
    font-weight: bold;
    width: 150px;
    border-left: 1px solid #d68584;
  }

  .c-btn-active + .c-btn {
    border-left: 1px solid #d68584;
  }

  .c-btn-active::after {
    content: "";
    width: 150px;
    height: 1px;
    background-color: rgba(182, 11, 13, 1);
    position: absolute;
    left: 0;
    top: 0;
  }

  .c-btn:last-child {
    border-right: 1px solid #d68584;
  }
</style>



// WEBPACK FOOTER //
// src/components/cheader.vue